import { listenTo, createRef } from './helpers';
import { Database } from 'firebase/database';

export default function onChildAddedFactory(database: Database) {
  return function onChildAddedFunction(
    this: any,
    path: string,
    signal: string,
    options: Parameters<typeof createRef>[2] & {
      payload?: Record<string, any>;
    } = {}
  ) {
    listenTo(
      createRef(database, path, options),
      path,
      'child_added',
      signal,
      (data: any) => {
        this.context.app.getSequence(signal)({
          key: data.key,
          value: data.val(),
          ...(options.payload || {}),
        });
      }
    );
  };
}
